import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { currencyLabel, formatAmount } from '@/lib/format'
import { useI18n } from '@/lib/i18n'

interface PriceProps {
    value: number
    className?: string
    currencyClassName?: string
    strike?: boolean
}

/** A price as number plus currency, kept on one line. */
export const Price: FC<PriceProps> = ({ value, className, currencyClassName, strike }): ReactNode => {
    const { locale } = useI18n()

    return (
        <span className={cn('inline-flex items-baseline gap-1 whitespace-nowrap', strike && 'line-through decoration-1', className)}>
            <span className='tabular-nums'>{formatAmount(value)}</span>
            <span className={cn('text-[0.72em] font-medium', currencyClassName)}>{currencyLabel(locale)}</span>
        </span>
    )
}

/** A bare number, isolated in its own element so surrounding words stay separate. */
export const Num: FC<{ value: number, className?: string }> = ({ value, className }): ReactNode => (
    <span className={cn('tabular-nums', className)}>{formatAmount(value)}</span>
)
